import { Button, Row } from '@components'
import { StyleColumn, StyleTypography } from '@components/styles'
import { StyleNoteWrapper } from '../style'
interface PageBreadCrumProps {
  title: string
  onClick: () => void
}

const PageBreadCrum: React.FC<PageBreadCrumProps> = ({ title, onClick }) => {
  return (
    <StyleNoteWrapper>
      <StyleColumn customStyle={{ width: '100%', rowGap: 10 }}>
        <StyleTypography fontSize={16} fontWeight={500}>
          {title}
        </StyleTypography>
        <Row justifyContent="space-between" alignItems="center">
          <StyleTypography fontSize={14} customStyle={{}}>
            Write all the content you want to showcase on the {title} page.
          </StyleTypography>
          <Button
            title={`View ${title}`}
            onClick={onClick}
            type="button"
            height={40}
          />
        </Row>
      </StyleColumn>
    </StyleNoteWrapper>
  )
}
export default PageBreadCrum
